import { Check, X } from "lucide-react";

const ROWS = [
  ["File types supported", "200+", "60", "80", "120"],
  ["Sync speed", "Up to 1 GB/s", "150 MB/s", "200 MB/s", "300 MB/s"],
  ["Natural language search", true, false, "limited", false],
  ["Team workspaces", "Unlimited", "5 seats", "10 seats", "Unlimited"],
  ["Reels / short-form feed", true, false, false, false],
  ["Starting price", "$4 / mo", "$15 / mo", "$10 / mo", "$12 / mo"],
];
const COLS = ["Monster Squad", "Shade", "Dropbox", "Frame.io"];

const Cell = ({ v }) => {
  if (v === true) return <Check className="w-4 h-4 text-[#E60000]" strokeWidth={2} />;
  if (v === false) return <X className="w-4 h-4 text-black/30" strokeWidth={2} />;
  return <span className="text-sm">{v}</span>;
};

export const PricingTable = () => (
  <div className="border border-black/15">
    <div className="grid grid-cols-5 border-b border-black/15 bg-black text-white">
      <div className="p-4 text-xs uppercase tracking-[0.2em] font-bold">Feature</div>
      {COLS.map((c, i) => (
        <div
          key={c}
          className={`p-4 text-sm font-heading font-black tracking-tight ${i === 0 ? "bg-[#E60000]" : ""}`}
        >
          {c}
        </div>
      ))}
    </div>
    {ROWS.map((row, rowIdx) => (
      <div key={rowIdx} className="grid grid-cols-5 border-b border-black/10 last:border-b-0">
        <div className="p-4 text-sm font-medium tracking-tight">{row[0]}</div>
        {row.slice(1).map((v, i) => (
          <div key={i} className={`p-4 flex items-center ${i === 0 ? "bg-[#E60000]/5" : ""}`}>
            <Cell v={v} />
          </div>
        ))}
      </div>
    ))}
  </div>
);
